import initializationReducer from './initialization'
import acceptInvitationReducer from './acceptInvitation'
import setupMFAWebAuthnReducer from './setupMFAWebAuthn'
import setupMFATOTPReducer from './setupMFATOTP'
import formCommonReducer from './formCommon'
import settings from './settings'

export default {
  initialization: initializationReducer,
  acceptInvitation: acceptInvitationReducer,
  formCommon: formCommonReducer,
  setupMFAWebAuthn: setupMFAWebAuthnReducer,
  setupMFATOTP: setupMFATOTPReducer,
  settings
}
